export default {
  insertionSort (a, func, from, to) {
    // 排序
    from |= 0
    to |= a.length
    for (var i = from + 1; i < to; i++) {
      var element = a[i]
      for (var j = i - 1; j >= from; j--) {
        var tmp = a[j]
        if (func(tmp, element) > 0) {
          a[j + 1] = tmp
        } else {
          break
        }
      }
      a[j + 1] = element
    }
  },
  serialize (obj) {
    const str = []
    for (let p in obj) {
      if (obj.hasOwnProperty(p)) {
        str.push(
          encodeURIComponent(p) +
          '=' +
          encodeURIComponent(this.isNothing(obj[p]) ? '' : obj[p])
        )
      }
    }
    return str.join('&')
  },
  isNothing (value) {
    return (
      value === '' ||
      value === '-' ||
      value === undefined ||
      value === null ||
      value === 'NaN' ||
      (typeof value === 'number' && (isNaN(value) || !isFinite(value)))
    )
  },
  getURLParameter (name) {
    const result =
      decodeURIComponent(
        (new RegExp('[?|&]' + name + '=([^&;]+?)(&|#|;|$)').exec(
          window.location.href
        ) || [undefined, ''])[1].replace(/\+/g, '%20')
      ) || null
    return result
  },
  getUrlParams (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[\[\]]/g, '\\$&')
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),  // eslint-disable-line
      results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  },

  downloadExcel (params) {
    const { config, listData, excelName } = params
    const downloadURL = '/common/exportExcel'
    let form = document.createElement('form')
    form.style = 'display: none'
    form.method = 'post'
    form.action = downloadURL

    let input = document.createElement('input')
    input.type = 'hidden'
    input.name = 'exportForm'
    input.value = JSON.stringify({
      config,
      listData,
      excelName
    })

    form.appendChild(input)
    document.body.appendChild(form)

    form.submit()
  }
}
